import React from 'react'
import { siteScrollImg, partner1, partner2, partner3, partner4, partner5 } from '../../asserts/images'

const Partners = () => {
  return (
    <div className="container-fluid p-0">
            <div>
              <div class="marquee-container trusted-partnerContainer">
                <div class="marquee">
                <div class="trustedPartners">
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner1} alt="partner1"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner2} alt="partner2"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner3} alt="partner3"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner4} alt="partner4"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner5} alt="partner5"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner1} alt="partner6"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner2} alt="partner7"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner3} alt="partner8"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner4} alt="partner9"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner5} alt="partner10"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner1} alt="partner11"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner2} alt="partner12"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner3} alt="partner13"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner4} alt="partner14"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner5} alt="partner15"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner1} alt="partner16"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner2} alt="partner17"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner3} alt="partner18"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner4} alt="partner19"></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner5} alt="partner20"></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </div>
  )
}

export default Partners